import { render, staticRenderFns } from "./SearchResultInvestment.vue?vue&type=template&id=1f3cfb32"
import script from "./SearchResultInvestment.vue?vue&type=script&lang=js"
export * from "./SearchResultInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports